module.exports = __webpack_public_path__ + "icon-linkedin.svg";